import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className="header-clean">
      <div className="header-container-clean">
        <div className="header-logo-clean" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <span className="logo-text-clean">Shailey Singh</span>
        </div>

        <nav className={`header-nav-clean ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <button onClick={() => scrollToSection('hero')} className="nav-link-clean">
            Home
          </button>
          <button onClick={() => scrollToSection('case-studies')} className="nav-link-clean">
            Select Work
          </button>
          <button onClick={() => scrollToSection('about')} className="nav-link-clean">
            About
          </button>
          <button onClick={() => scrollToSection('thought')} className="nav-link-clean">
            Insights
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link-clean nav-cta-clean">
            Contact
          </button>
        </nav>

        <button
          className="mobile-menu-toggle-clean"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;